import { useEffect } from "react";
import { useSelector } from "react-redux";
import DefaultLogo from "../../../assets/images/logo.png";

const OrganizationMetadata = () => {
   const organization = useSelector((state) => state.config?.configs?.organization || {});
   const configRevision = useSelector((state) => state.config?.revision || 0);
   const name = organization.organization_name || "Organization";
   const description = organization.organization_description || organization.description ||
      `Manage ${name} operations in one place.`;
   const logo = organization.organization_logo || DefaultLogo;

   useEffect(() => {
      document.title = name;

      let descriptionTag = document.querySelector('meta[name="description"]');
      if (!descriptionTag) {
         descriptionTag = document.createElement("meta");
         descriptionTag.setAttribute("name", "description");
         document.head.appendChild(descriptionTag);
      }
      descriptionTag.setAttribute("content", description);

      const iconLinks = document.querySelectorAll('link[rel="icon"], link[rel="apple-touch-icon"]');
      const versionedLogo = logo.startsWith("data:")
         ? logo
         : `${logo}${logo.includes("?") ? "&" : "?"}v=${configRevision}`;
      iconLinks.forEach((iconLink) => iconLink.setAttribute("href", versionedLogo));
   }, [name, description, logo, configRevision]);

   return null;
};

export default OrganizationMetadata;
